import React, { useState } from "react";
import { EMPTY_PLAN_FORM } from "../lib/planPresets";

const DEFAULT_FORM = {
  ...EMPTY_PLAN_FORM,
  name: "",
  valid_until: "",
};

export default function CreatePlanModal({ onClose, onCreate, loading }) {
  const [form, setForm] = useState({
    ...DEFAULT_FORM,
    effective_from: new Date().toISOString().slice(0, 10),
    valid_until: "",
  });
  const [error, setError] = useState("");

  const onField = (field) => (e) => {
    const val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [field]: val }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name.trim()) {
      setError("Nombre del plan requerido");
      return;
    }
    if (form.fallback_tokens_model === "FLAT" && !form.fallback_tokens_included) {
      setError("Indicá el máximo de tokens fallback incluidos (FLAT)");
      return;
    }
    try {
      await onCreate({
        name: form.name.trim(),
        arca_enabled: form.arca_enabled,
        copilot_enabled: form.copilot_enabled,
        max_documents_monthly:
          form.max_documents_monthly === "" ? null : Number(form.max_documents_monthly),
        fallback_tokens_model: form.fallback_tokens_model,
        fallback_tokens_included:
          form.fallback_tokens_model === "FLAT" ? Number(form.fallback_tokens_included) : null,
        monthly_base_fee_ars:
          form.monthly_base_fee_ars === "" ? null : Number(form.monthly_base_fee_ars),
        valid_from: form.effective_from || null,
        valid_until: form.valid_until || null,
        status: "active",
      });
      onClose();
    } catch (err) {
      setError(err.message || "No se pudo crear el plan");
    }
  };

  return (
    <div className="ops-modal-backdrop">
      <div className="ops-modal ops-modal-wide">
        <h3>Nuevo plan comercial</h3>
        <p className="ops-subtitle">Definí los 4 parámetros facturables y la vigencia del plan.</p>
        {error && <p className="ops-error">{error}</p>}
        <form onSubmit={handleSubmit} className="ops-form-grid">
          <label style={{ gridColumn: "1 / -1" }}>
            Nombre del plan *
            <input value={form.name} onChange={onField("name")} placeholder="ej. Growth 2026" required />
          </label>
          <label className="ops-toggle">
            <input type="checkbox" checked={form.arca_enabled} onChange={onField("arca_enabled")} />
            ARCA habilitado
          </label>
          <label className="ops-toggle">
            <input type="checkbox" checked={form.copilot_enabled} onChange={onField("copilot_enabled")} />
            Copilot habilitado
          </label>
          <label>
            Documentos / mes (vacío = ilimitado)
            <input type="number" value={form.max_documents_monthly} onChange={onField("max_documents_monthly")} />
          </label>
          <label>
            Modelo tokens fallback
            <select value={form.fallback_tokens_model} onChange={onField("fallback_tokens_model")}>
              <option value="FLAT">FLAT (cupo máximo incluido)</option>
              <option value="PAY_AS_YOU_GO">PAY_AS_YOU_GO</option>
            </select>
          </label>
          {form.fallback_tokens_model === "FLAT" && (
            <label>
              Tokens fallback incluidos (máximo) *
              <input
                type="number"
                value={form.fallback_tokens_included}
                onChange={onField("fallback_tokens_included")}
                required
              />
            </label>
          )}
          <label>
            Fee mensual base (ARS)
            <input type="number" value={form.monthly_base_fee_ars} onChange={onField("monthly_base_fee_ars")} />
          </label>
          <label>
            Vigencia desde
            <input type="date" value={form.effective_from} onChange={onField("effective_from")} />
          </label>
          <label>
            Vigencia hasta
            <input type="date" value={form.valid_until} onChange={onField("valid_until")} />
          </label>
          <div className="ops-actions" style={{ gridColumn: "1 / -1" }}>
            <button type="button" className="ops-btn secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="ops-btn" disabled={loading}>
              {loading ? "Creando…" : "Crear plan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
